import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Button from 'Components/UI/Button';
import { Link } from 'react-router-dom';
import {
  householdTimelineUri,
} from 'Consts/advisorUris';
import TimelineNotes from 'Components/AdvisorApp/Viewport/ClientExperienceSaves/TimelineNotes';
import { missionControlURL } from 'Hooks/useMissionControlURL';
import HouseholdInfo from './HouseholdInfo';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  linkButton: {
    minWidth: theme.spacing(0),
    justifyContent: 'start',
  },
  button: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  quickLinks: {
    listStyle: 'none',
    marginBottom: theme.spacing(0),
    paddingLeft: theme.spacing(0),
  },
});

function SaveHouseholdDetails({ classes, selectedEscalatedHousehold, ...rest }) {
  const mcURL = missionControlURL(selectedEscalatedHousehold, selectedEscalatedHousehold?.attr('householdId'));
  const getContent = () => (
    <Paper variant="outlined">
      <div className={classes.root}>
        <Typography
          variant="h2"
          color="primary"
        >
          {selectedEscalatedHousehold.attr('primaryClientFullName')} ({selectedEscalatedHousehold.attr('householdId')})
        </Typography>
        <Typography
          variant="h4"
          color="primary"
        >
        Household Information
        </Typography>
        <HouseholdInfo
          selectedEscalatedHousehold={selectedEscalatedHousehold}
        />
        <TimelineNotes />
        <Typography
          variant="h4"
          color="primary"
        >
        Quick Links
        </Typography>
        <ul className={classes.quickLinks}>
          <li>
            <Button
              className={classes.linkButton}
              component={Link}
              color="primaryGray"
              padding="none"
              size="small"
              to={householdTimelineUri(selectedEscalatedHousehold.id())}
            >
              Timeline
            </Button>
          </li>
          {mcURL
            ? (
              <li>
                <Button
                  className={classes.linkButton}
                  component={Link}
                  padding="none"
                  color="primaryGray"
                  size="small"
                  to={mcURL}
                >
                  Mission Control
                </Button>
              </li>
            ) : null
          }
        </ul>
      </div>
    </Paper>
  );
  return (
    <div className={classNames(classes.root)} {...rest}>
      { selectedEscalatedHousehold && getContent() }
    </div>
  );
}
SaveHouseholdDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedEscalatedHousehold: PropTypes.object.isRequired,
};

export default withStyles(styles)(SaveHouseholdDetails);
